import React, { Component } from 'react';
import 'semantic-ui-css/semantic.min.css';
import { Modal, Button } from 'semantic-ui-react';
import SelectEmployees from '../../../Commons/SelectEmployees';
import FilterGroupSection, { emptyFilterGroup, normalizeFilterGroup } from '../../../Commons/FilterGroupSection';

class EmploymentHistoryReportModal extends Component {

    constructor(props) {
        super(props);
        var defaultState = {
            filterGroup: emptyFilterGroup(),
            filterEmpIds: [],
        };

        const savedState = sessionStorage.getItem("EmploymentHistoryReportFilterState");
        if (savedState) {
            try {
                const parsed = JSON.parse(savedState);
                this.state = { ...defaultState, ...parsed, filterGroup: normalizeFilterGroup(parsed.filterGroup) };
            } catch (e) {
                this.state = defaultState;
            }
        } else {
            this.state = defaultState;
        }
    }

    componentWillUnmount() {
        const stateToSave = {
            filterGroup: this.state.filterGroup,
            filterEmpIds: this.state.filterEmpIds
        };
        sessionStorage.setItem("EmploymentHistoryReportFilterState", JSON.stringify(stateToSave));
    }

    getParameters = () => {
        return {
            ...this.state.filterGroup,
            employeeIds: this.state.filterEmpIds
        };
    }

    updateEmpIds = (ids) => {
		this.setState({ filterEmpIds: ids });
	}

    render() {
        return (
            <Modal open={this.props.open} size="tiny">
                <Modal.Header>
                    <p>Employee </p>
                </Modal.Header>
                <Modal.Content>
                    <div class="ui grid">
                        <div class="left floated left aligned sixteen wide column">
                            <FilterGroupSection value={this.state.filterGroup} onChange={filterGroup => this.setState({ filterGroup })} />
                        </div>
                    </div>
                    <label>Employee</label>
                    <SelectEmployees filterGroup={this.state.filterGroup} Ids={this.state.filterEmpIds} update={this.updateEmpIds.bind(this)} style={{ minWidth: '50px', maxWidth: '100%', width: '100%' }} />
                </Modal.Content>
                <Modal.Actions>
                    <Button basic content="Generate" onClick={() => this.props.callback(this.state.filterEmpIds, this.state.filterGroup)}></Button>
                    <Button basic content="Cancel" onClick={this.props.onCancel}></Button>
                </Modal.Actions>
            </Modal>
        );
    }

}

export default EmploymentHistoryReportModal;